/* External dependencies */
import get from 'lodash/get';

/* Internal dependencies */
import { listArtistsForUser } from '../../api/artists';
import { updateUser } from '../../store/ducks/users';
import { PaginationOptions } from '../../types/Pagination';
import { put, select } from '../../store/reduxStory';
import { listCreatedEventsForUser, listEventsForUser } from '../../api/events';
import { listAnswersForUser } from '../../api/answers';
import { listGenresForUser } from '../../api/genres';
import { listTracksForUser } from '../../api/tracks';
import { addNotification } from '../../store/ducks/notifications';
import { getCurrentUser, updateCurrentUser } from '../../store/ducks/currentUser';
import { followUser, unfollowUser } from '../../api/users';
import { ParticipantStatus } from '../../types/Participant';

export const addUserFollow = async (user: any) => {
  const currentUser = select(getCurrentUser);
  const currentUserFollowing = get(currentUser, 'following', []);

  if (!currentUser) return;
  
  try {
    put(updateUser({
      ...user,
      followed: true,
      followedStatus: ParticipantStatus.confirmed,
    }));
    // put(
    //   updateCurrentUser({
    //     ...currentUser,
    //     following: [...currentUserFollowing, user],
    //   })
    // );
    
    return await followUser(user);
  } catch {
    user.followed = false;
    put(updateUser({
      ...user,
      followedStatus: undefined,
    }));
    put(updateCurrentUser({ ...currentUser }));
  }
};

export const removeUserFollow = async (user: any) => {
  const currentUser = select(getCurrentUser);
  const currentUserFollowing = get(currentUser, 'following', []);

  if (!currentUser) return;

  const { id } = user;
  const userIndex = currentUserFollowing.findIndex(({ id: userId }: any) => id === userId);

  try {
    put(updateUser({
      ...user,
      followed: false,
      followedStatus: undefined,
    }));
    // put(
    //   updateCurrentUser(
    //     cleanObject({
    //       ...currentUser,
    //       following:
    //       userIndex !== -1
    //           ? [...currentUserFollowing.slice(0, userIndex), ...currentUserFollowing.slice(userIndex + 1)]
    //           : undefined,
    //     })
    //   )
    // );
    return await unfollowUser(user);
  } catch {
    user.followed = true;
    put(updateUser({
      ...user,
      followedStatus: ParticipantStatus.confirmed,
    }));
  }
};

export const toggleUserFollow = async (user: any) => {
  const followed = get(user, 'followed', false);

  if (Boolean(followed)) {
    put(
      addNotification({
        title: 'User unfollowed',
        message: `You unfollowed ${get(user, 'name', 'the user')}.`,
        items: [user],
        variant: 'primary',
      })
    );
    removeUserFollow(user);
  } else {
    addUserFollow(user);
    put(
      addNotification({
        title: 'User followed',
        message: `You followed ${get(user, 'name', 'the user')}.`,
        items: [user],
        variant: 'primary',
      })
    );
  }
};

const getUserArtists = async (userId: string, options: PaginationOptions) => {
  const response = await listArtistsForUser(userId, options);
  const items = get(response, 'items', []);
  const offset = get(response, 'offset', []);
  const total = get(response, 'total', []);

  put(updateUser({
    artists: items,
    artistsOffset: offset,
    artistsTotal: total,
  }));
};

const getUserEvents = async (userId: string, options: PaginationOptions) => {
  const response = await listEventsForUser(userId, options);
  const items = get(response, 'items', []);
  const offset = get(response, 'offset', []);
  const total = get(response, 'total', []);

  put(updateUser({
    events: items,
    eventsOffset: offset,
    eventsTotal: total,
  }));
};

const getUserCreatedEvents = async (userId: string, options: PaginationOptions) => {
  const response = await listCreatedEventsForUser(userId, options);
  const items = get(response, 'items', []);
  const offset = get(response, 'offset', []);
  const total = get(response, 'total', []);

  put(updateUser({
    createdEvents: items,
    createdEventsOffset: offset,
    createdEventsTotal: total,
  }));
};

// const getUserPastEvents = async (userId: string, options: PaginationOptions) => {
//   const response = await listPastEventsForUser(userId, options);
//   const items = get(response, 'items', []);
//   const offset = get(response, 'offset', []);
//   const total = get(response, 'total', []);

//   put(updateUser({
//     createdEvents: items,
//     createdEventsOffset: offset,
//     createdEventsTotal: total,
//   }));
// };

const getUserAnswers = async (userId: string, options: PaginationOptions) => {
  const response = await listAnswersForUser(userId, options);
  const items = get(response, 'answers', []);

  put(updateUser({
    answers: items,
  }));
};

const getUserGenres = async (userId: string, options: PaginationOptions) => {
  const response = await listGenresForUser(userId, options);
  const items = get(response, 'items', []);
  const offset = get(response, 'offset', []);
  const total = get(response, 'total', []);

  put(updateUser({
    genres: items,
    genresOffset: offset,
    genresTotal: total,
  }));
};

const getUserTracks = async (userId: string, options: PaginationOptions) => {
  const response = await listTracksForUser(userId, options);
  const items = get(response, 'items', []);
  const offset = get(response, 'offset', []);
  const total = get(response, 'total', []);

  put(updateUser({
    tracks: items,
    tracksOffset: offset,
    tracksTotal: total,
  }));
};